/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface FancyScrollStyles {
    chevronUpIconStyle?: StyledProp;
    chevronDownIconStyle?: StyledProp;
    outerContainer?: StyledProp;
    overRelyStyle?: StyledProp;
}

export const styles: FancyScrollStyles = {
    chevronUpIconStyle: css`
        position: absolute;
        top: 15px;
        right: 15px;
        color: ${getColor("primary.main")};
        z-index: ${getProp("theme.zIndex.default")};
    `,
    chevronDownIconStyle: css`
        position: absolute;
        bottom: 15px;
        right: 15px;
        color: ${getColor("primary.main")};
        z-index: ${getProp("theme.zIndex.default")};
    `,
    outerContainer: css`
        max-width: 100%;
        max-height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    `,
    overRelyStyle: css`
        height: 50px;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.7) 43.24%,
            ${getColor("common.background")} 100%
        );
        pointer-events: none;
    `,
};
